import * as React from "react";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  size?: number;
}

export const PathfinderTriangleIcon: React.FC<Props> = ({ className, size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 287 274"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("shrink-0", className)}
  >
    <path d="M143.5 0L0 273.1L143.5 206.67L287 273.1L143.5 0Z" fill="currentColor" />
  </svg>
);
